// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import apiFun from "@/http/api.js";
// 引入 我们准备好的 store
import store from '@/store/index.js'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI);
import  "amfe-flexible";
import Vant from 'vant';
import 'vant/lib/index.css';
import './theme-premium.css';
Vue.use(Vant);

// 全局注册
Vue.prototype.$apiFun = apiFun;//请求接口api

Vue.config.productionTip = false

// 记录各页离开时的滚动位置，用于返回 keep-alive 页面时还原（避免每次回首页都弹回顶部）
var pageScrollMap = {};
router.afterEach((to, from, next) => {
  var keep = to.matched.some(function (r) {
    return r.meta && r.meta.keepAlive;
  });
  if (keep && pageScrollMap[to.fullPath] != null) {
    // keep-alive 页面 DOM 已缓存，等重新插入后还原滚动位置
    var y = pageScrollMap[to.fullPath];
    Vue.nextTick(function () {
      requestAnimationFrame(function () {
        window.scrollTo(0, y);
      });
    });
  } else {
    window.scrollTo(0, 0); //新页面/首次进入 keep-alive 页面：回到顶部
    if (document.querySelector('.index-page')) {
      document.querySelector('.index-page').scrollTo(0, 0);
    }
  }
});
// 路由改成按需加载后多了一个失败模式：弱网下分包没拉下来，vue-router
// 不会重试，用户就卡在空白页。这里兵不血刃地刷一次（重新拿 index.html +
// 重新请求分包），并用 sessionStorage 打标防死循环 —— 如果刷完还是拉不到，
// 就不再刷了，否则网络真的断了会变成无限刷新。
router.onError(function (err) {
  var msg = (err && err.message) || '';
  if (!/Loading( CSS)? chunk \S* failed/i.test(msg)) {
    return;
  }
  if (sessionStorage.getItem('chunk_reloaded')) {
    return;
  }
  sessionStorage.setItem('chunk_reloaded', '1');
  window.location.reload();
});
router.afterEach(function () {
  // 成功进入新路由就把标清掉，下次再出问题还能救一次
  sessionStorage.removeItem('chunk_reloaded');
});

router.beforeEach((to, from, next) => {
  // 离开当前页前保存其滚动位置
  pageScrollMap[from.fullPath] = window.scrollY || document.documentElement.scrollTop || 0;
  let token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
  if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆
    if (localStorage.getItem('token')) { // 查询本地存储信息是否已经登陆
      next();
    } else {
      next({
        path: '/login', // 未登录则跳转至login页面
        query: { redirect: to.fullPath } // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
      });
    }
  } else {
    next();
  }


});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,//使用store
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js